import { render } from "./star-rating-link.vue?vue&type=template&id=7da58260"
import script from "./star-rating-link.vue?vue&type=script&lang=js"
export * from "./star-rating-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__